module.exports = __webpack_public_path__ + "static/media/bg3.39c52722.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/bg3.png
// module id = 1217
// module chunks = 0